import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/success.svg` */
export const SuccessIcon = createTripletGlyphIcon('SuccessIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.5254 5.71191C10.7401 5.49736 11.088 5.49737 11.3027 5.71191C11.5174 5.92665 11.5173 6.27448 11.3027 6.48926L7.54785 10.2451C7.31432 10.4787 6.93758 10.4853 6.69629 10.2598L4.70996 8.40137C4.48851 8.19381 4.47717 7.84572 4.68457 7.62402C4.89208 7.40257 5.2402 7.39136 5.46191 7.59863L7.10254 9.13379L10.5254 5.71191Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.34277 1.34277C11.8651 1.52141 14.666 4.43426 14.666 8.00098L14.6572 8.34375C14.4783 11.8657 11.5663 14.6668 8 14.667L7.65625 14.6582C4.24794 14.4852 1.51489 11.7521 1.3418 8.34375L1.33301 8.00098C1.33301 4.31925 4.31831 1.33317 8 1.33301L8.34277 1.34277ZM8 2.33398C4.87059 2.33415 2.33301 4.87153 2.33301 8.00098C2.33351 11.13 4.87091 13.6668 8 13.667C11.129 13.6667 13.6655 11.1299 13.666 8.00098C13.666 4.87158 11.1293 2.33423 8 2.33398Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.8896 6.47461C12.1044 6.25997 12.4522 6.25999 12.667 6.47461C12.8817 6.68937 12.8817 7.03718 12.667 7.25195L8.44238 11.4775C8.20583 11.7139 7.82438 11.7206 7.58008 11.4922L5.3457 9.40137C5.12426 9.1938 5.11292 8.84571 5.32031 8.62402C5.52783 8.40253 5.87593 8.39131 6.09766 8.59863L7.99219 10.3711L11.8896 6.47461Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.38574 1.50977C13.3484 1.7106 16.4999 4.98747 16.5 9L16.4902 9.38574C16.2894 13.3484 13.0126 16.4999 9 16.5L8.61426 16.4902C4.77921 16.296 1.70413 13.2208 1.50977 9.38574L1.5 9C1.50013 4.85805 4.85802 1.5 9 1.5L9.38574 1.50977ZM9 2.59961C5.46554 2.59961 2.59974 5.46557 2.59961 9C2.59968 12.5345 5.4655 15.3994 9 15.3994C12.5344 15.3993 15.3993 12.5344 15.3994 9C15.3993 5.46561 12.5344 2.59968 9 2.59961Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.8408 8.62109C16.1337 8.32833 16.6085 8.32828 16.9014 8.62109C17.1941 8.91395 17.1941 9.38877 16.9014 9.68164L14.085 12.4985L11.2686 15.3154C10.9468 15.637 10.428 15.6457 10.0957 15.335L7.11621 12.5479C6.81412 12.2649 6.79851 11.7907 7.08105 11.4883C7.36403 11.1858 7.83912 11.1701 8.1416 11.4531L10.6562 13.8057L15.8408 8.62109Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5146 2.0127C17.7981 2.28063 21.9999 6.65 22 12L21.9863 12.5146C21.7184 17.7981 17.35 21.9999 12 22L11.4854 21.9863C6.37222 21.7272 2.27199 17.6277 2.0127 12.5146L2 12C2.0001 6.47734 6.47732 2 12 2L12.5146 2.0127ZM12 3.5C7.30574 3.5 3.5001 7.30577 3.5 12C3.5001 16.6942 7.30574 20.5 12 20.5C16.6942 20.4999 20.4999 16.6942 20.5 12C20.4999 7.30583 16.6942 3.5001 12 3.5Z"
        fill="currentColor"
      />
    </svg>
  ),
});
